import { Button } from "antd";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import DashboardIcon from "../assets/icons/dashboard.svg";
import { auth } from "../firebase";
import { useStateValue } from "../state/StateProvider";

const Sidebar = () => {
	const [{ batons }] = useStateValue();
	const navigate = useNavigate();

	const handleLogout = () => {
		auth.signOut();
		navigate("/login");
	};

	return (
		<div className='h-full fixed w-40 pt-[50px] flex flex-col justify-between'>
			<Link to="/batons">
				<div className='flex items-center gap-4 my-4 mx-3 cursor-pointer'>
					<img src={DashboardIcon} alt='Dashboard' />
					<span className='font-semibold text-primary'>Baton Library</span>
				</div>
			</Link>
			<hr className='border-none bg-gray-200 h-[1px]' />
			<div className='px-3 py-2 flex flex-col gap-2 flex-1'>
				{batons.map((baton) => (
					<div key={baton._id}>
						<Link to={`/batons/${baton._id}`}>
							<span className='cursor-pointer text-black hover:text-primary'>
								{baton.name}
							</span>
						</Link>
					</div>
				))}
			</div>
			<Button
				type='text'
				className='font-bold text-primary self-center my-4 hover:text-primary'
				onClick={handleLogout}
			>
				Logout
			</Button>
		</div>
	);
};

export default Sidebar;
